/**
 * 融宝 接口的统一出口
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const apply = {
    // 列表
    list(params) {
        return axios.get(api + 'reapalapply/list', {params: params})
    },
    // 详情
    detail(params) {
        return axios.get(api + 'reapalapply/detail', {params: params})
    },
    //修改
    edit(params) {
        return axios.post(api + 'reapalapply/edit', qs.stringify(params))
    },
    //添加
    create(params) {
        return axios.post(api + 'reapalapply/create', qs.stringify(params))
    },
    // 上传
    upload(params) {
        return axios.post(api + 'reapalapply/upload', qs.stringify(params))
    },
    // 绑卡
    bindCard(params) {
        return axios.post(api + 'reapalapply/bindCard', qs.stringify(params))
    },
    // 卡信息
    cardDetail(params) {
        return axios.post(api + 'reapalapply/zldetail', qs.stringify(params))
    },
    //卡列表
    cardlist(params) {
        return axios.get(api + 'reapalapply/cardlist', {params: params})
    },
    //解绑卡
    unbindcard(params) {
        return axios.post(api + 'reapalapply/unbindcard', qs.stringify(params))
    },
    //设置支付密码
    paypwd(params) {
        return axios.post(api + 'reapalapply/paypwd', qs.stringify(params))
    }
}


// 导出接口
export default apply